import { render, staticRenderFns } from "./ProspectJudges.vue?vue&type=template&id=c1f13e9a&scoped=true&"
import script from "./ProspectJudges.vue?vue&type=script&lang=js&"
export * from "./ProspectJudges.vue?vue&type=script&lang=js&"
import style0 from "./ProspectJudges.vue?vue&type=style&index=0&id=c1f13e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f13e9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VSelect,VTextField})
